import { ConstraintConfigurationInput, ConstraintCreateMutationVariables } from '@occc/graphql';
import { Operation } from '@occc-app/offerHelpers/types';
import { makeRequiresActivationConstraintConfiguration } from '@occc-app/offerHelpers/operations/makeRequiresActivationConstraintConfiguration';

export type CreateConstraintOperationType = Operation<
  'constraintCreate',
  ConstraintCreateMutationVariables
>;

export const makeCreateConstraint = (
  offerId: string,
  configuration: ConstraintConfigurationInput,
): CreateConstraintOperationType => {
  return {
    name: 'constraintCreate',
    variables: {
      input: {
        offerId,
        configuration,
      },
    },
  };
};

export const makeCreateRequiresActivationConstraintOperation = (
  offerId: string,
  allowMultipleFulfillmentsOnActivation: boolean,
  mustFulfillWithinDays?: number,
): CreateConstraintOperationType => {
  const configuration = makeRequiresActivationConstraintConfiguration(
    allowMultipleFulfillmentsOnActivation,
    mustFulfillWithinDays,
  );

  return makeCreateConstraint(offerId, configuration);
};
